/* Auto generated by gulp-typescript-template */

export const headingTemplate = `<div class="content-item -heading _clear"></div>`;
